var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.track)?_c('span',[(_vm.track.color)?_c('i',{staticClass:"far fa-square color-preview",style:({color: _vm.track.color})}):_vm._e(),_vm._v(" "+_vm._s(_vm.track.name)+" "),(_vm.currentUser.isDeveloper && _vm.track.id > 0)?_c('span',[_vm._v(" ("+_vm._s(_vm.$t('id'))+": "+_vm._s(_vm.track.id)+")")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }